import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

export default function AuthCallback() {
  const processed = useRef(false);
  const nav = useNavigate();
  const { setSession } = useAuth();

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(window.location.hash.replace(/^#/, "")).get("session_id");
    window.history.replaceState(null, "", window.location.pathname);
    if (!sessionId) { nav("/admin/login", { replace: true }); return; }
    api.post("/auth/session", { session_id: sessionId })
      .then(({ data }) => { setSession(data); toast.success(`Welcome, ${data.user.name}`); nav(data.user.role === "customer" ? "/customer" : "/admin", { replace: true, state: { user: data.user } }); })
      .catch((e) => { toast.error(e?.response?.data?.detail || "Google sign-in failed"); nav("/admin/login", { replace: true }); });
  }, [nav, setSession]);

  return (
    <div data-testid="auth-callback" className="min-h-screen flex items-center justify-center text-zinc-500 font-mono text-xs uppercase tracking-widest">
      Establishing secure session…
    </div>
  );
}
